import script from "./compWorkflowTable.vue?vue&type=script&setup=true&lang=js"
export * from "./compWorkflowTable.vue?vue&type=script&setup=true&lang=js"

import "./compWorkflowTable.vue?vue&type=style&index=0&id=1cdb5868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cdb5868"]])

export default __exports__